import { render } from "./ChangePayPassword.vue?vue&type=template&id=b203aa12&scoped=true"
import script from "./ChangePayPassword.vue?vue&type=script&lang=js"
export * from "./ChangePayPassword.vue?vue&type=script&lang=js"

import "./ChangePayPassword.vue?vue&type=style&index=0&id=b203aa12&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b203aa12"]])

export default __exports__